import { EquipmentSuccessToastProps } from 'services/equipment/types';
import { ToastProvider } from 'hooks/use-toast/toast-context';
import { DealerLocatorModal } from 'components/dealer-locator';
import { DealerLocatorModalProvider } from 'components/dealer-locator/dealer-locator-modal-context';
import AddEquipmentSuccessToast from 'components/my-equipment/add-equipment-widget/add-equipment-success-toast';

const EquipmentSuccessToast = ({
  userDetail
}: Readonly<EquipmentSuccessToastProps>) => {
  return (
    <DealerLocatorModalProvider>
      <ToastProvider>
        <AddEquipmentSuccessToast isLoggedIn={userDetail.isLoggedIn} />
        <DealerLocatorModal
          autoSearch={!userDetail.isLoggedIn || userDetail.isInstantAccessUser}
          isRegistration
        />
      </ToastProvider>
    </DealerLocatorModalProvider>
  );
};

export default EquipmentSuccessToast;
